var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('module-card',[_c('p',[_vm._v("Now that you know a bit more about the effects of alcohol and drugs, match the substances you’ve learned about with the potential impact on your BottomLine.")])])}
var staticRenderFns = []

export { render, staticRenderFns }